import { Component, OnInit } from '@angular/core';
import { CmsBlockComponent } from '../cms-block.component';
import { CmsElementService } from '../../../services/cms-element.service';
import { CmsSlot } from '../../../models/cms-slot';
import { SafeHtml } from '@angular/platform-browser';
import { CmsAbstractBlockComponent } from '../cms-abstract-block.component';

@Component({
    selector: 'app-cms-text-two-column',
    templateUrl: './cms-text-two-column.component.html',
    standalone: false,
})
export class CmsTextTwoColumnComponent
    extends CmsAbstractBlockComponent
    implements OnInit, CmsBlockComponent
{
    left: CmsSlot;
    right: CmsSlot;

    leftContent: SafeHtml;
    rightContent: SafeHtml;

    constructor(private cmsElementService: CmsElementService) {
        super();
    }

    ngOnInit(): void {
        this.initBlock();
        this.loadComponent();
    }

    loadComponent(): void {
        this.left = this.slots.find((slot) => slot.slot === 'left');
        this.right = this.slots.find((slot) => slot.slot === 'right');

        this.leftContent = this.cmsElementService.renderContent(this.left);
        this.rightContent = this.cmsElementService.renderContent(this.right);
    }
}
